import { useState } from "react";
import { ExternalLink } from "lucide-react";

// Live website preview thumbnail (WordPress mShots). Falls back to nothing (logo-only card) on load error.
export const PreviewThumb = ({ url, name, label = "Visit Website" }) => {
  const [err, setErr] = useState(false);
  if (err) return null;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="block relative rounded-xl overflow-hidden border border-gray-100 mb-3 aspect-[16/10] bg-gray-50 group/prev" data-testid="preview-thumb">
      <img
        src={`https://s.wordpress.com/mshots/v1/${encodeURIComponent(url)}?w=640&h=400`}
        alt={`${name} website preview`}
        loading="lazy"
        onError={() => setErr(true)}
        className="w-full h-full object-cover object-top group-hover/prev:scale-105 transition-transform duration-500"
      />
      <span className="absolute bottom-2 right-2 inline-flex items-center gap-1 text-[10px] font-bold text-white bg-black/60 backdrop-blur-sm rounded-full px-2.5 py-1 opacity-0 group-hover/prev:opacity-100 transition-opacity">{label} <ExternalLink size={10} /></span>
    </a>
  );
};
